import axios from "../../lib/axiosInstance";

export const createQualification = (payload) =>
  axios.post("/qualifications", payload).then((r) => r.data);

export const createSubQualification = (payload) =>
  axios
    .post("/qualifications/subQualifications/bulk", payload)
    .then((r) => r.data);

export const fetchQualificationTypes = async (payload = {}) => {
  const queryParams = new URLSearchParams();

  if (payload.page) queryParams.append("page", payload.page);
  if (payload.limit) queryParams.append("limit", payload.limit);
  if (payload.search?.trim())
    queryParams.append("search", payload.search.trim());

  const res = await axios.get(
    `qualifications${
      queryParams.toString() ? `?${queryParams.toString()}` : ""
    }`
  );
  return res.data;
};

export const fetchSubQualificationTypes = async (id, payload = {}) => {
  const queryParams = new URLSearchParams();

  if (payload.page) queryParams.append("page", payload.page);
  if (payload.limit) queryParams.append("limit", payload.limit);
  if (payload.search?.trim())
    queryParams.append("search", payload.search.trim());

  const res = await axios.get(
    `qualifications/subQualificationsByQualificationId/${id}${
      queryParams.toString() ? `?${queryParams.toString()}` : ""
    }`
  );
  return res.data;
};
export const fetchAllSubQualificationTypes = async (payload = {}) => {
  const queryParams = new URLSearchParams();

  if (payload.page) queryParams.append("page", payload.page);
  if (payload.limit) queryParams.append("limit", payload.limit);
  if (payload.search?.trim())
    queryParams.append("search", payload.search.trim());

  const res = await axios.get(
    `qualifications/subQualifications${
      queryParams.toString() ? `?${queryParams.toString()}` : ""
    }`
  );
  return res.data;
};
